//logout

export const POST_LOGOUT_REQUEST = "POST_LOGOUT_REQUEST";
export const POST_LOGOUT_ERROR = "POST_LOGOUT_ERROR";
export const POST_LOGOUT_SUCCESS = "POST_LOGOUT_SUCCESS";